import React, { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import IndustriesList from '../../pages/industries/industries-list';

function PagesRoute() {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route exact path={`${path}`} component={IndustriesList} />
        </Switch>
    );
}

export default PagesRoute;
